import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { EventCategories, EventActions } from '../../../../constants/Analytics';
import { Modal, Card, Button, HeadingFour, HeadingFive, Theme } from 'hui/src/styled';
import { ucFirst } from '../../../../utils/string';
import { popupCard } from './SharedStyles';
import OutsideAlerter from './RefWrapper';

const Cross = () => (
  <svg width="16px" height="18px" viewBox="0 0 16 18">
    <g id="cross" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect
        id="Rectangle"
        fill="#A1A1A3"
        transform="translate(8.142136, 9.142136) rotate(-45.000000) translate(-8.142136, -9.142136) "
        x="7.14213562"
        y="-0.857864376"
        width="2"
        height="20"
        rx="1"
      />
      <rect
        id="Rectangle"
        fill="#A1A1A3"
        transform="translate(8.142136, 9.142136) rotate(-45.000000) translate(-8.142136, -9.142136) "
        x="-1.85786438"
        y="8.14213562"
        width="20"
        height="2"
        rx="1"
      />
    </g>
  </svg>
);

class ConfirmationPopup extends Component {
  state = {
    isOpen: false
  };
  render() {
    const { getCurrentCategory, close, step } = this.props;
    const { isOpen } = this.state;
    const CloseButton = styled.a`
      justify-content: right;
      margin-right: 4px;
      font-size: 1.2rem;
      cursor: pointer;
      color: ${Theme.greyMedium};
      & :hover {
        color: ${Theme.greyLight};
      }
    `;
    const openModal = () => {
      this.setState({ isOpen: true });
    };
    const closeModal = () => {
      this.setState({ isOpen: false });
    };

    return (
      <React.Fragment>
        <CloseButton
          onClick={() => openModal()}
          title="close"
          data-ga-interactive={false}
          data-ga-category={EventCategories.POST_JOB_MODAL}
          data-ga-action={`${EventActions.PRESS_CLOSE} ${ucFirst(step.toLowerCase())} Screen`}
          data-ga-label={getCurrentCategory}
        >
          <Cross />
        </CloseButton>
        <Modal isOpen={isOpen} ariaHideApp={false}>
          <OutsideAlerter onClick={() => closeModal()}>
            <Card snow center p={0} m={0} style={popupCard}>
              <HeadingFour mb={1}>You&#39;re almost there!</HeadingFour>
              <HeadingFive mb={1}>Local tradies are ready to help</HeadingFive>
              <Button m={0.5} onClick={() => closeModal()}>
                Stay &#38; continue
              </Button>
              <Button
                back
                tag="a"
                ghost
                m={0.5}
                onClick={close}
                title="close"
                style={{
                  color: Theme.danger,
                  border: 0
                }}
              >
                Clear my progress
              </Button>
            </Card>
          </OutsideAlerter>
        </Modal>
      </React.Fragment>
    );
  }
}

ConfirmationPopup.propTypes = {
  question: PropTypes.object,
  onSubmit: PropTypes.func,
  back: PropTypes.func,
  close: PropTypes.func,
  step: PropTypes.string,
  answered: PropTypes.bool,
  getCurrentCategory: PropTypes.any,
  CategoryType: PropTypes.any
};

export default ConfirmationPopup;
